/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import api from "@virgodev/bazaar/functions/api";
// import { list, save, delete, load } from "../../ma÷nagers/api";

export async function get(url: string, params = null) {
  const response = await api({
    url: url,
    params: params,
  });
  if (response.ok) {
    return response.body;
  }
  throw new Error(JSON.stringify({ status: response.status }));
}
export async function get_with_id(url: string, id: string) {
  const response = await api({ url: `${url}${id}/` });
  if (response.ok) {
    return response.body;
  }
  throw new Error(JSON.stringify({ status: response.status }));
}
// export async function post_or_put(url: string, object: object, put: boolean) {
//   const update = !!object.id;
//   if (update) {
//     url += `${object.id}/`;
//   }
//   const response = await api({
//     url,
//     method: put ? "PATCH" : update ? "PUT" : "POST",
//     json: object,
//   });
//   if (response.ok) {
//     object.id = response.body.id;
//   }
//   return response;
// }
// export async function delete_function(url: string, id: number) {
//   return api({ url: `${url}${id}/`, method: "DELETE" });
// }
// async getCustomers(id = null) {
//   let url = "customers/";
//   if (id) {
//     url += `?id=${id}`;
//   }
//   const response = await api({
//     url: url,
//   });
//   if (response.status == 200) {
//     return response.body;
//   }
//   return null;
// },
// async getUserInfo(id = null) {
//   const response = await api({
//     url: `users/?id=${id}`,
//   });
//   if (response.status == 200) {
//     return response.body;
//   }
//   return null;
// },
// async getRentals(id = null) {
//   let url = "rentals/";
//   if (id) {
//     url += `?id=${id}`;
//   }
//   const response = await api({
//     url: url,
//   });
//   if (response.status == 200) {
//     return response.body;
//   }
//   return null;
// },
// async getCustomersWithRentals() {
//   const rentals = await this.getRentals();
//   const customers = await this.getCustomers();
//   for (const customer of customers.value) {
//     customer.rentals = null;
//     const rental_list = rentals.value.filter(
//       (item) => item.customer_id == customer.id
//     );
//     if (rental_list) {
//       customer.rentals = rental_list;
//     }
//   }
//   return customers;
// },
// async getUnit(id = null) {
//   let url = "units/";
//   if (id) {
//     url += `?id=${id}`;
//   }
//   const response = await api({
//     url: url,
//   });
//   if (response.status == 200) {
//     return response.body;
//   }
//   return null;
// },
// async getUnitTypes(id = null) {
//   let url = "unit_types/";
//   if (id) {
//     url += `?id=${id}`;
//   }
//   const response = await api({
//     url: url,
//   });
//   if (response.status == 200) {
//     return response.body;
//   }
//   return null;
// },
// async getRentalWithUnitDetails(id = null) {
//   const rentals = await this.getRentals(id);
//   for (const rental of rentals.value) {
//     const details = await this.getUnit(rental.id);
//     rental.details = details;
//     const unit_type = await this.getUnitTypes(rental.details.unit_type_id);
//     rental.unit_type = unit_type;
//   }
// },
